/**
 * Cómo se numera un proceso.
 *
 * ⚠ **El numeral se DERIVA, no se guarda.** El origen —`setieca_procesos`— tenía una
 * columna `numeral` con «I», «II» y «⊕» escritos a mano, y eso se desincroniza en
 * cuanto alguien reordena: quedan dos procesos con el mismo romano, o un hueco. Aquí
 * sale del orden y de si es transversal, así que reordenar lo recalcula solo.
 *
 * ⚠ **Un proceso transversal no lleva número, lleva ⊕.** No es la etapa siguiente:
 * corre a lo largo de todas. Numerarlo como una más diría que el control normativo
 * es un trámite del final, que es justo lo contrario de lo que es.
 */

/** El símbolo de lo transversal. Es el que usa la agencia en su manual. */
export const MARCA_TRANSVERSAL = "⊕"

const ROMANOS: [number, string][] = [
  [1000, "M"],
  [900, "CM"],
  [500, "D"],
  [400, "CD"],
  [100, "C"],
  [90, "XC"],
  [50, "L"],
  [40, "XL"],
  [10, "X"],
  [9, "IX"],
  [5, "V"],
  [4, "IV"],
  [1, "I"],
]

/** Un entero positivo en números romanos. Fuera de rango devuelve el número. */
export function aRomano(n: number): string {
  if (!Number.isInteger(n) || n < 1 || n > 3999) return String(n)
  let resto = n
  let salida = ""
  for (const [valor, letra] of ROMANOS) {
    while (resto >= valor) {
      salida += letra
      resto -= valor
    }
  }
  return salida
}

/**
 * El numeral de un proceso dentro de su lista.
 *
 * ⚠ **La posición se cuenta entre los SECUENCIALES.** Si el transversal está en
 * medio de la lista por su `orden`, los que vienen detrás no deben saltarse un
 * número: la cadena de etapas es I…VII con transversal o sin él.
 */
export function numeralDeProceso(
  procesos: { id: number; es_transversal?: boolean }[],
  id: number,
): string {
  const proceso = procesos.find((p) => p.id === id)
  if (proceso === undefined) return ""
  if (proceso.es_transversal === true) return MARCA_TRANSVERSAL
  const secuenciales = procesos.filter((p) => p.es_transversal !== true)
  return aRomano(secuenciales.findIndex((p) => p.id === id) + 1)
}
